import { Button } from '@ps/isp-web-component-library';
import { useTrackers } from '@ps/web-shared-analytics';
import { Translation, useTrackingLabel } from '@ps/web-shared-components';
import { Loader } from '@ps/web-shared-ui';
import React from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import useTotals from '../../../../../../../../hooks/useTotals';
import { getIsDailyMaxPayoutLimitReached } from '../../../../../../../../utils/isDailyMaxPayoutLimitReached';

import { TXTWCL_Place_Bet } from './PlaceBetButton.messages.json';

const PlaceBetButton: React.FC = () => {
  const { totalStake, totalPotentialReturns } = useTotals();
  const isBetPlacementAvailable = useSelector(select.betSlip.isBetPlacementAvailable);
  const dailyMaxPayoutLimit = useSelector(select.betSlip.dailyMaxPayoutLimit);
  const fetchStatus = useSelector(select.betSlip.fetchStatus);
  const selectedPromotionPicker = useSelector(select.betSlip.selectedPromotionPicker);
  const buttonName = useTrackingLabel(TXTWCL_Place_Bet);
  const { buttonPressed } = useTrackers();
  const { getState } = useForm();
  const { submitting: isSubmitting } = useFormState();
  const { hasValidationErrors } = getState();

  const isDailyMaxPayoutLimitReached = getIsDailyMaxPayoutLimitReached(
    dailyMaxPayoutLimit,
    totalPotentialReturns
  );
  const isDisabled =
    !isBetPlacementAvailable ||
    !totalStake ||
    hasValidationErrors ||
    fetchStatus === 'AUTH_UPDATE_PENDING' ||
    isDailyMaxPayoutLimitReached ||
    Boolean(selectedPromotionPicker);

  return (
    <Button
      type="submit"
      onClick={() => buttonPressed({ buttonName })}
      disabled={isDisabled}
      size="medium"
    >
      {isSubmitting ? <Loader /> : <Translation {...TXTWCL_Place_Bet} />}
    </Button>
  );
};

export default PlaceBetButton;
